import { IProcedure } from "../../typings/filterEntities";
import ProcedureCard from "../ProcedureCard/ProcedureCard";
import Wrapper from "../Wrapper/Wrapper";
import styles from "./SimilarProceduresGrid.module.css";

interface IProps {
  data: IProcedure[];
  except?: string;
}

export default function SimilarProceduresGrid({ data, except }: IProps) {
  return (
    <aside className={styles.root} id="similar_procedures">
      <Wrapper>
        <h3 className={styles.heading}>Similar procedures</h3>
        <ul className={styles.grid}>
          {data.map((p) =>
            p.uid !== except ? (
              <li className={styles.gridItem} key={p.uid}>
                <ProcedureCard procedure={p} />
              </li>
            ) : null,
          )}
        </ul>
      </Wrapper>
    </aside>
  );
}
